import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, Link as RouterLink } from 'react-router-dom'
import { Box, Chip, FormControlLabel, Link, Switch, Typography } from '@mui/material'
import { COLORS, ROUTES } from 'config/constants'
import { applicationsListPath, applicationDetailPath } from 'utils/applicationRoutes'
import HeaderTitle from '../../../common/headerTitle'
import ApplicationStatusIcon from '../status-icon'
import { getApplicationStatusLabel } from '../status-label'

import './detail-header.scss'

const ApplicationDetailHeader = ({ app, managerView, canManageApplications }: ApplicationDetailHeaderProps) => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const breadcrumbs = [
    <Link
      key='main'
      component={RouterLink}
      to={`/${ROUTES.CABINET}`}
      underline='hover'
      sx={{
        color: COLORS.LIGHT_TEXT_SECONDARY,
        cursor: 'pointer',
      }}
    >
      <Typography variant='body2'>{t('menu__text__main')}</Typography>
    </Link>,
    <Link
      key='applications'
      component={RouterLink}
      to={applicationsListPath()}
      underline='hover'
      sx={{
        color: COLORS.LIGHT_TEXT_SECONDARY,
        cursor: 'pointer',
      }}
    >
      <Typography variant='body2'>{t('applications__text__title')}</Typography>
    </Link>,
  ]

  return (
    <header className='application-detail-header'>
      <div className='application-detail-header__heading'>
        <HeaderTitle
          breadcrumbs={breadcrumbs}
          titleText={(
            <Box component='span' className='application-detail-header__title' sx={{ gap: 2 }}>
              <Box component='span' sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 2,
              }}>
                <ApplicationStatusIcon status={app.status} label={app.status_label} size={32} />
                <Typography component='span' variant='h4' sx={{ fontWeight: 700 }}>
                  {t('applications__text__applicationNumber', { number: app.public_id })}
                </Typography>
              </Box>
              <Chip component='span' label={(
                <Typography component='span' variant='inherit'>
                  {getApplicationStatusLabel({ status: app.status, fallback: app.status_label, translate: t })}
                </Typography>
              )} />
            </Box>
          )}
        />
        {canManageApplications && (
          <FormControlLabel
            labelPlacement='start'
            sx={{
              margin: 0,
              flexShrink: 0,
            }}
            control={(
              <Switch
                checked={managerView}
                onChange={(_event, checked) => navigate(
                  applicationDetailPath({ publicId: app.public_id, managerView: checked }),
                  { replace: true },
                )}
                inputProps={{ 'aria-label': t('applications__text__switchToManagerView') }}
              />
            )}
            label={(
              <Typography component='span' variant='body2'>
                {t('applications__text__switchToManagerView')}
              </Typography>
            )}
          />
        )}
      </div>
    </header>
  )
}

export default ApplicationDetailHeader
